import React from 'react';
import PropTypes from 'prop-types';

export const RadioGroup = ({ name, dataField, updateValue }) => (
  <div>
    <div className="field is-left is-horizontal">
      <label className="radio">
        <input
          checked={dataField === 'Excellent'}
          name={name}
          onChange={updateValue}
          type="radio"
          value="Excellent"
        />{' '}
        Excellent
      </label>
    </div>
    <div className="field is-left is-horizontal">
      <label className="radio">
        <input
          checked={dataField === 'Good'}
          name={name}
          onChange={updateValue}
          type="radio"
          value="Good"
        />{' '}
        Good
      </label>
    </div>
    <div className="field is-left is-horizontal">
      <label className="radio">
        <input
          checked={dataField === 'Neutral'}
          name={name}
          onChange={updateValue}
          type="radio"
          value="Neutral"
        />{' '}
        Neutral
      </label>
    </div>
    <div className="field is-left is-horizontal">
      <label className="radio">
        <input
          checked={dataField === 'Need improvement'}
          name={name}
          onChange={updateValue}
          type="radio"
          value="Need improvement"
        />{' '}
        Needs improvement
      </label>
    </div>
    {/* <div className="field is-left is-horizontal">
      <label className="radio">
        <input
          checked={dataField === 'Very poor'}
          name={name}
          onChange={updateValue}
          type="radio"
          value="Very poor"
        />{' '}
        Very poor
      </label>
    </div> */}
  </div>
);

RadioGroup.propTypes = {
  dataField: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  updateValue: PropTypes.func.isRequired
};

export default RadioGroup;
